import { captureExceptionWithContext } from "@/sentry";

import { trackAmplitude } from "./impl/amplitude";
import { normalizeEventData } from "./normalize";

/**
 * Tracks an analytics event. The event data must be an object where all values
 * are either strings in kebab case, numbers, or booleans.
 *
 * @param {Object} params - The parameters for the analytics event.
 * @param {string} params.event - The event name.
 */
export function trackEvent(params) {
  const { event, ...data } = params;
  try {
    trackAmplitude(event, normalizeEventData(data));
  } catch (e) {
    captureExceptionWithContext(e, { event: { params } });
  }
}
